import { Link } from 'react-router-dom'

import { Card, CardBody, CardHeader } from '@/components/ui/Card'
import type { VenueNoticeReadStatusView } from '@/lib/venue/campaignPerformanceTypes'
import { readRateText } from '@/lib/venue/campaignViewModel'

/**
 * 운영 공지 열람 현황 탭(요구 4, #734 §1-5) — 비용·전환 지표와 섞이지 않도록 별도 카드로 둔다.
 * 🔒 `VenueNoticeReadStatusView`에는 비용·전환 필드가 타입 자체에 없어 렌더할 여지가 없다.
 */
export function NoticeReadStatusSummaryCard({
  data,
  venueId,
}: {
  data: VenueNoticeReadStatusView
  venueId: string
}) {
  return (
    <Card>
      <CardHeader title="운영 공지 열람 현황" description="비용·전환 지표는 운영 공지에 적용되지 않습니다." />
      <CardBody>
        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <dt className="text-xs text-slateish-600">발송 공지 수</dt>
            <dd className="mt-1 text-lg font-semibold text-ink-700">
              {data.campaignCount.toLocaleString('ko-KR')}건
            </dd>
          </div>
          <div>
            <dt className="text-xs text-slateish-600">발송 성공/실패</dt>
            <dd className="mt-1 text-sm text-ink-700">
              {data.successCount.toLocaleString('ko-KR')} / {data.failedCount.toLocaleString('ko-KR')}
            </dd>
          </div>
          <div>
            <dt className="text-xs text-slateish-600">열람(수/율)</dt>
            <dd className="mt-1 text-lg font-semibold text-ink-700">
              {data.readCount.toLocaleString('ko-KR')} / {readRateText(data.readRatePercent)}
            </dd>
          </div>
          <div>
            <dt className="text-xs text-slateish-600">미열람</dt>
            <dd className="mt-1 text-sm text-ink-700">{data.unreadCount.toLocaleString('ko-KR')}</dd>
          </div>
        </dl>
        <Link to={`/venues/${venueId}/notices/history`} className="mt-4 inline-block text-sm text-brand-500 underline">
          운영 공지별 상세 내역 보기
        </Link>
      </CardBody>
    </Card>
  )
}
